export function importIntlRelativeTimeFormatLocaleData(locale: string) {
  switch (locale) {
    case 'de':
      return import(
        '@formatjs/intl-relativetimeformat/locale-data/de' /* webpackChunkName: 'intl-relativetimeformat-locale-data-de' */
      );
    case 'ja':
      return import(
        '@formatjs/intl-relativetimeformat/locale-data/ja' /* webpackChunkName: 'intl-relativetimeformat-locale-data-ja' */
      );
    case 'es':
      return import(
        '@formatjs/intl-relativetimeformat/locale-data/es' /* webpackChunkName: 'intl-relativetimeformat-locale-data-es' */
      );
    case 'es-mx':
      return import(
        '@formatjs/intl-relativetimeformat/locale-data/es-MX' /* webpackChunkName: 'intl-relativetimeformat-locale-data-es-MX' */
      );
    case 'id':
      return import(
        '@formatjs/intl-relativetimeformat/locale-data/id' /* webpackChunkName: 'intl-relativetimeformat-locale-data-id' */
      );
    case 'ko':
      return import(
        '@formatjs/intl-relativetimeformat/locale-data/ko' /* webpackChunkName: 'intl-relativetimeformat-locale-data-ko' */
      );
    case 'ms':
      return import(
        '@formatjs/intl-relativetimeformat/locale-data/ms' /* webpackChunkName: 'intl-relativetimeformat-locale-data-ms' */
      );
    case 'ru':
      return import(
        '@formatjs/intl-relativetimeformat/locale-data/ru' /* webpackChunkName: 'intl-relativetimeformat-locale-data-ru' */
      );
    case 'th':
      return import(
        '@formatjs/intl-relativetimeformat/locale-data/th' /* webpackChunkName: 'intl-relativetimeformat-locale-data-th' */
      );
    case 'tr':
      return import(
        '@formatjs/intl-relativetimeformat/locale-data/tr' /* webpackChunkName: 'intl-relativetimeformat-locale-data-tr' */
      );
    case 'uk':
      return import(
        '@formatjs/intl-relativetimeformat/locale-data/uk' /* webpackChunkName: 'intl-relativetimeformat-locale-data-uk' */
      );
    case 'vi':
      return import(
        '@formatjs/intl-relativetimeformat/locale-data/vi' /* webpackChunkName: 'intl-relativetimeformat-locale-data-vi' */
      );
    case 'da':
      return import(
        '@formatjs/intl-relativetimeformat/locale-data/da' /* webpackChunkName: 'intl-relativetimeformat-locale-data-da' */
      );
    case 'fr':
      return import(
        '@formatjs/intl-relativetimeformat/locale-data/fr' /* webpackChunkName: 'intl-relativetimeformat-locale-data-fr' */
      );
    case 'it':
      return import(
        '@formatjs/intl-relativetimeformat/locale-data/it' /* webpackChunkName: 'intl-relativetimeformat-locale-data-it' */
      );
    case 'nl':
      return import(
        '@formatjs/intl-relativetimeformat/locale-data/nl' /* webpackChunkName: 'intl-relativetimeformat-locale-data-nl' */
      );
    case 'pl':
      return import(
        '@formatjs/intl-relativetimeformat/locale-data/pl' /* webpackChunkName: 'intl-relativetimeformat-locale-data-pl' */
      );
    case 'pt':
    case 'pt-br':
      return import(
        '@formatjs/intl-relativetimeformat/locale-data/pt' /* webpackChunkName: 'intl-relativetimeformat-locale-data-pt' */
      );
    case 'sv':
      return import(
        '@formatjs/intl-relativetimeformat/locale-data/sv' /* webpackChunkName: 'intl-relativetimeformat-locale-data-sv' */
      );
    case 'fi':
      return import(
        '@formatjs/intl-relativetimeformat/locale-data/fi' /* webpackChunkName: 'intl-relativetimeformat-locale-data-fi' */
      );
    case 'cs':
      return import(
        '@formatjs/intl-relativetimeformat/locale-data/cs' /* webpackChunkName: 'intl-relativetimeformat-locale-data-cs' */
      );
    case 'bg':
      return import(
        '@formatjs/intl-relativetimeformat/locale-data/bg' /* webpackChunkName: 'intl-relativetimeformat-locale-data-bg' */
      );
    case 'ca':
      return import(
        '@formatjs/intl-relativetimeformat/locale-data/ca' /* webpackChunkName: 'intl-relativetimeformat-locale-data-ca' */
      );
    case 'hr':
      return import(
        '@formatjs/intl-relativetimeformat/locale-data/hr' /* webpackChunkName: 'intl-relativetimeformat-locale-data-hr' */
      );
    case 'et':
      return import(
        '@formatjs/intl-relativetimeformat/locale-data/et' /* webpackChunkName: 'intl-relativetimeformat-locale-data-et' */
      );
    case 'el':
      return import(
        '@formatjs/intl-relativetimeformat/locale-data/el' /* webpackChunkName: 'intl-relativetimeformat-locale-data-el' */
      );
    case 'hu':
      return import(
        '@formatjs/intl-relativetimeformat/locale-data/hu' /* webpackChunkName: 'intl-relativetimeformat-locale-data-hu' */
      );
    case 'lv':
      return import(
        '@formatjs/intl-relativetimeformat/locale-data/lv' /* webpackChunkName: 'intl-relativetimeformat-locale-data-lv' */
      );
    case 'lt':
      return import(
        '@formatjs/intl-relativetimeformat/locale-data/lt' /* webpackChunkName: 'intl-relativetimeformat-locale-data-lt' */
      );
    case 'ro':
      return import(
        '@formatjs/intl-relativetimeformat/locale-data/ro' /* webpackChunkName: 'intl-relativetimeformat-locale-data-ro' */
      );
    case 'sr':
      return import(
        '@formatjs/intl-relativetimeformat/locale-data/sr' /* webpackChunkName: 'intl-relativetimeformat-locale-data-sr' */
      );
    case 'sk':
      return import(
        '@formatjs/intl-relativetimeformat/locale-data/sk' /* webpackChunkName: 'intl-relativetimeformat-locale-data-sk' */
      );
    case 'sl':
      return import(
        '@formatjs/intl-relativetimeformat/locale-data/sl' /* webpackChunkName: 'intl-relativetimeformat-locale-data-sl' */
      );
    case 'sw':
      return import(
        '@formatjs/intl-relativetimeformat/locale-data/sw' /* webpackChunkName: 'intl-relativetimeformat-locale-data-sw' */
      );
    case 'is':
      return import(
        '@formatjs/intl-relativetimeformat/locale-data/is' /* webpackChunkName: 'intl-relativetimeformat-locale-data-is' */
      );
    case 'fil':
      return import(
        '@formatjs/intl-relativetimeformat/locale-data/fil' /* webpackChunkName: 'intl-relativetimeformat-locale-data-fil' */
      );
    case 'ar':
      return import(
        '@formatjs/intl-relativetimeformat/locale-data/ar' /* webpackChunkName: 'intl-relativetimeformat-locale-data-ar' */
      );
    case 'he':
      return import(
        '@formatjs/intl-relativetimeformat/locale-data/he' /* webpackChunkName: 'intl-relativetimeformat-locale-data-he' */
      );
    case 'mt':
      return import(
        '@formatjs/intl-relativetimeformat/locale-data/mt' /* webpackChunkName: 'intl-relativetimeformat-locale-data-mt' */
      );
    case 'az':
      return import(
        '@formatjs/intl-relativetimeformat/locale-data/az' /* webpackChunkName: 'intl-relativetimeformat-locale-data-az' */
      );
    case 'ka':
      return import(
        '@formatjs/intl-relativetimeformat/locale-data/ka' /* webpackChunkName: 'intl-relativetimeformat-locale-data-ka' */
      );
    case 'gl':
      return import(
        '@formatjs/intl-relativetimeformat/locale-data/gl' /* webpackChunkName: 'intl-relativetimeformat-locale-data-gl' */
      );
    case 'eu':
      return import(
        '@formatjs/intl-relativetimeformat/locale-data/eu' /* webpackChunkName: 'intl-relativetimeformat-locale-data-eu' */
      );
    case 'fr-ca':
      return import(
        '@formatjs/intl-relativetimeformat/locale-data/fr-CA' /* webpackChunkName: 'intl-relativetimeformat-locale-data-fr-CA' */
      );
    case 'zh-hant':
      return import(
        '@formatjs/intl-relativetimeformat/locale-data/zh-Hant' /* webpackChunkName: 'intl-relativetimeformat-locale-data-zh-Hant' */
      );
    case 'zh-hans':
      return import(
        '@formatjs/intl-relativetimeformat/locale-data/zh-Hans' /* webpackChunkName: 'intl-relativetimeformat-locale-data-zh-Hans' */
      );
    case 'no':
      // Norwegian bokmål (nb) is the dominant language in Norway
      return import(
        '@formatjs/intl-relativetimeformat/locale-data/nb' /* webpackChunkName: 'intl-relativetimeformat-locale-data-nb' */
      );
    default:
      return import(
        '@formatjs/intl-relativetimeformat/locale-data/en' /* webpackChunkName: 'intl-relativetimeformat-locale-data-en' */
      );
  }
}
